<template>
  <div v-resize="handelResizeBanner">
    <div class="main-banner">
      <div class="banner-image">
        <app-image :id="18"></app-image>
      </div>
      <div class="app-container grid grid-header">
        <div class="banner-content">
          <h4>{{ $t('views.home.mainBanner.typeOrganization') }}</h4>
          <h1>{{ $t('views.home.mainBanner.title') }}</h1>
          <p>{{ $t('views.home.mainBanner.aboutOrganization') }}</p>
          <p class="mb-0">
            {{ $t('views.home.mainBanner.membership-infopark') }}
          </p>
          <p>{{ $t('views.home.mainBanner.membership-htp') }}</p>
          <social-links />
        </div>

        <div v-if="showBannerImg && false" class="banner-img-content">
          <img src="../../assets/logoIPPS.png" alt="" />
        </div>
      </div>
    </div>

    <about-us></about-us>
    <activities></activities>
    <counter-area></counter-area>
    <news></news>
    <projects></projects>
    <partners></partners>
    <contacts></contacts>
  </div>
</template>

<script>
import AppImage from '@/components/AppImage';
import AboutUs from './components/AboutUs';
import Activities from './components/Activities';
import Contacts from './components/Contacts';
import CounterArea from './components/CounterArea';
import News from './components/News';
import Partners from './components/Partners';
import Projects from './components/Projects';
import SocialLinks from '@/components/SocialLinks';

import { Resize } from '@/directive/resize';

export default {
  name: 'Home',
  components: {
    AppImage,
    AboutUs,
    Activities,
    Contacts,
    CounterArea,
    News,
    Partners,
    Projects,
    SocialLinks,
  },
  directives: {
    Resize,
  },
  data: () => ({
    showBannerImg: null,
  }),
  created() {
    this.handelResizeBanner();
  },
  methods: {
    handelResizeBanner() {
      this.showBannerImg = window.innerWidth > 840;
    },
  },
};
</script>

<style lang="stylus" scoped>
.main-banner {
  position: relative;
  height: 755px;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
    themify(
      $themes,
      @($theme) {
      background: $theme.$gradient--primary--color;
    }
    );
  }

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    themify(
      $themes,
      @($theme) {
      background: $theme.$gradient--secondary--color;
    }
    );
  }

  .banner-image {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .banner-content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    justify-content: center;
    height: 100%;
    z-index: 4;

    h1 {
      margin-bottom: 3rem;
    }

    h4 {
      padding: 8px 12px;
      margin-bottom: 1.5rem;
      border-radius: 4px;
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      line-height: 16px;
      themify(
        $themes,
        @($theme) {
        color: $theme.$secondary--light--color;
        background: $theme.$primary--light--color;
      }
      );
    }

    h1, p {
      themify(
        $themes,
        @($theme) {
        color: $theme.$primary--light--color;
      }
      );
    }
  }

  .banner-img-content {
    display: flex;
    align-items center;
    justify-content: center;

    img {
      position: relative;
      width: 325px;
      z-index: 4;
    }
  }
}

.pt-100 {
  padding-top: 100px;
}

.banner {
  img {
    width: 100%;
    object-fit contain;
    border-radius: 30px;
  }
}
</style>
